import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { Grid, Col } from '@koaly/grid';
import { rem } from '@koaly/mixins';
import React from 'react';
import { up, down } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import { ObjectFit } from '../ObjectFit/ObjectFit.js';
import { TitleContent } from '../TitleContent/TitleContent.js';

const StyledContentMedia = styled(Grid).attrs({ forwardedAs: 'section' }) `
  padding: ${({ theme }) => theme.tokens.contentSectionMobilePaddingVertical} 0;

  ${up('s')} {
    padding: ${({ theme }) => theme.tokens.contentSectionMobilePadding} 0;
  }

  ${({ mediaPosition }) => mediaPosition === 'left' &&
    css `
      ${up('s')} {
        flex-direction: row-reverse;
      }
    `};
`;
const Media = styled(ObjectFit) `
  border-radius: 40px;
  max-height: ${rem(320)};
  height: 100%;

  ${down('xs')} {
    max-height: ${rem(320)};
  }

  ${({ theme, mediaElevation }) => mediaElevation && `box-shadow: ${theme.elevations[3]};`};
`;
const ContentMedia = (_a) => {
    var { media, mediaPosition, mediaElevation, mediaObjectPosition, mediaFit } = _a, titleContentProps = __rest(_a, ["media", "mediaPosition", "mediaElevation", "mediaObjectPosition", "mediaFit"]);
    return (React.createElement(StyledContentMedia, { gutter: 10, gutterRows: 10, mediaPosition: mediaPosition },
        React.createElement(Col, { width: { xs: 1, s: 5 / 12 }, flex: true, valign: "center" },
            React.createElement(TitleContent, Object.assign({}, titleContentProps))),
        React.createElement(Col, { visible: { xs: false, s: true } }),
        React.createElement(Col, { width: { xs: 1, s: 6 / 12 }, flex: true, valign: "center", halign: "center" },
            React.createElement(Media, { fit: mediaFit, mediaElevation: mediaElevation, objectPosition: mediaObjectPosition }, media))));
};
ContentMedia.defaultProps = {
    mediaPosition: 'right',
    mediaElevation: false,
};

export { ContentMedia };
//# sourceMappingURL=ContentMedia.js.map
